import { Table, Typography } from "antd"
import dayjs from "dayjs"
import { camelCaseToWords } from "../utils/string.utils"
import { ReactNode } from "react"
import { ColumnsType } from "antd/es/table"

const objectKeysToColumns = (obj:any, transform?:{[key:string]: (value:any)=>ReactNode}, labelTransform?: {[key:string]:string}):ColumnsType<[string, unknown]>=>{
    return [
        { title: "Field", width: '20%', dataIndex: ".", render:(field:any, record:any[])=>{
            if(labelTransform && labelTransform[record[0]])
            {
                return (<Typography.Text>{labelTransform[record[0]]}</Typography.Text>)
            } else {
                return (<Typography.Text>{camelCaseToWords(record[0])}</Typography.Text>)
            }
        }},
        { title: "Value", dataIndex: ".", render: (field:any, record:any[]) =>{
            let [key, value] = record;
            if(transform && transform[key])
            {
                let transformedElement = transform[key](value);
                return (
                    transformedElement
                );
            } else
             {
                if(typeof value == "object") {
                    return (
                        <Typography.Text copyable={{ text: JSON.stringify(value, null, 5), format: 'text/plain'}}>
                            <pre style={{width: 'calc(100% - 40px)', display:"inline-flex"}}>
                                {JSON.stringify(value, null, 5)}
                            </pre>
                        </Typography.Text>
                    );
                } else {
                    return (
                        <Typography.Text copyable>{ifDateFormatAsDateTime(value)}</Typography.Text>
                    )
                }
            }
            return <></>
        }}
    ]
}

const ifDateFormatAsDateTime = (value:any)=>{
    if(isNaN(value) && dayjs(value).isValid())
    {
        let date = dayjs(value).toDate();
        return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
    }
    return value;
}

export const ObjectToTable = (props: { object: any, filter:(key:string)=>boolean, transform?:{[key:string]: (value:any)=>ReactNode}, labelTransform?: {[key:string]: string}}) => {
    return (
        <Table 
            showHeader={false}
            size="small"
            columns={objectKeysToColumns(props.object, props.transform, props.labelTransform)}
            dataSource={Object.entries(props.object).filter(entry=>props.filter(entry[0]))}
            pagination={false}
            rowKey={(record: any) => `${JSON.stringify(record)}`}
        >

        </Table>
    )
}